import { FormControl, Validators } from '@angular/forms';


const SPECIAL_CHARS_PATTERN: RegExp = /^[^<>%#&?,]+$/;
const SPECIAL_CHARS_TEXT = '<>%#&?,';
const email_maxLenght: number = 128;
const name_maxLenght: number = 50;

export const userNameExists = 'userNameExists';


export class SearchControl implements ISearchControl {
	userName = new FormControl<string | null>(null, [Validators.maxLength(email_maxLenght), Validators.pattern(SPECIAL_CHARS_PATTERN), Validators.email]);
	showDeleted = new FormControl<boolean | null>(null);
	patientId = new FormControl<string | null>(null, [Validators.maxLength(name_maxLenght), Validators.pattern(SPECIAL_CHARS_PATTERN)]);
	planId = new FormControl<string | null>(null, [Validators.maxLength(name_maxLenght), Validators.pattern(SPECIAL_CHARS_PATTERN)]);
}

export const searchErrorMsgs: { [key in keyof SearchForm]: { [y: string]: string[] } | null } = {
	userName: {
		[`${Validators.maxLength.name.toLowerCase()}`]: ['VALIDATION_MESSAGE_MAXLENGTH_EMAIL', email_maxLenght.toString()],
		[`${Validators.pattern.name}`]: ['VALIDATION_MESSAGE_SPECIALCHARS_EMAIL', SPECIAL_CHARS_TEXT],
		[`${Validators.email.name}`]: ['VALIDATION_MESSAGE_FORMAT_EMAIL'],
		[`${userNameExists}`]: ['VALIDATION_MESSAGE_NOT_EXIST_USERNAME']
	},
	showDeleted: null,
	patientId: {
		[`${Validators.maxLength.name.toLowerCase()}`]: ['VALIDATION_MESSAGE_MAXLENGTH_PATIENTID', name_maxLenght.toString()],
		[`${Validators.pattern.name}`]: ['VALIDATION_MESSAGE_SPECIALCHARS_PATIENTID', SPECIAL_CHARS_TEXT]
	},
	planId: {
		[`${Validators.maxLength.name.toLowerCase()}`]: ['VALIDATION_MESSAGE_MAXLENGTH_PLANID', name_maxLenght.toString()],
		[`${Validators.pattern.name}`]: ['VALIDATION_MESSAGE_SPECIALCHARS_PLANID', SPECIAL_CHARS_TEXT]
	}
}

export interface ISearchControl {
	userName: FormControl<string | null>;
	showDeleted: FormControl<boolean | null>;
	patientId: FormControl<string | null>;
	planId: FormControl<string | null>;
}

/**
* Patient/plan filters form model.
*/
export interface SearchForm {
	userName: string;
	showDeleted: boolean;
	patientId: string;
	planId: string;
}

